var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('account-credit',{attrs:{"user-id":_vm.userId,"currency":_vm.currency}}),_c('payment-methods',{attrs:{"user-id":_vm.userId,"context":"select"},on:{"selected":function($event){return _vm.$emit('cartdata', { paymentMethod: $event })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }